export enum SOS_MENTAL_HEALTH_MODAL_ID {
  COMFIRM_IMMEDIATE_MODAL_PSICOLOGO = 'COMFIRM_IMMEDIATE_MODAL_PSICOLOGO',
  WAITING_TIME_SOS_MENTAL_HEALTH = 'WAITING_TIME_SOS_MENTAL_HEALTH',
}

export enum SPECIALTY {
  PSICOLOGO = 'PSICOLOGO',
}
